import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { ACCRUAL_MATCH_AUDIT_FIELD } from "@common/schemas/domains/accrualReview/accrual-match-audit-log.schema";
import { parseAccrualMatchSnapshot } from "@components/history/details/accrualMatches/schema";
import { AuditLogActor } from "../AuditLogActor";
import { describeAccrualMatchItems } from "../accrual/describeAccrualMatchItems";

interface Props {
    log: AuditLog;
}

export const TransactionLogAccrualMatchContent: React.FC<Props> = ({ log }) => {
    const authorComponent = (
        <AuditLogActor
            actorId={log.actorId}
            actorName={log.actorName}
            actorType={log.actorType}
            log={log}
        />
    );

    const diff = log.diff.find((d) => d.field === ACCRUAL_MATCH_AUDIT_FIELD);
    const matched = (diff?.after?.value ?? null) !== null;
    const snapshotValue = matched ? diff?.after?.value : diff?.before?.value;
    const snapshot = parseAccrualMatchSnapshot(snapshotValue);
    const summary = snapshot ? describeAccrualMatchItems(snapshot.items) : "";
    const description = summary || "items";

    if (matched) {
        return (
            <>
                {authorComponent} matched transaction with{" "}
                <strong>{description}</strong>.
            </>
        );
    }
    return (
        <>
            {authorComponent} unmatched transaction from{" "}
            <strong>{description}</strong>.
        </>
    );
};
